import axios from 'axios'
import {
    Message
} from 'element-ui'
// import store from '@/store'
// import {
//     getToken
// } from '@/utils/auth'
import {
    Loading
} from 'element-ui'
export default service => {
    let loading
    service.interceptors.request.use(
        config => {
            loading = new Loading.service({
                lock: true,
                text: '加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.1)'
            })
            // if (store.getters.token) {
            //     config.headers['Authorization'] = getToken()
            // }
            return config
        },
        error => {
            console.log(error)

            return Promise.reject(error)
        }
    )

    service.interceptors.response.use(
        response => {
            const res = response.data
            loading.close()
            if (res.code !== 200) {
                Message({
                    message: res.message || 'Error',
                    type: 'error',
                    duration: 5 * 1000
                })

                return Promise.reject(new Error(res.message || 'Error'))
            } else {
                return res
            }
        },
        error => {
            console.log('err' + error)
            Message({
                message: error.message,
                type: 'error',
                duration: 5 * 1000
            })
            loading.close()
            return Promise.reject(error)
        }
    )
}